import SavingsAgreement from 'features/accounts/savings/OpenSavingsAccount/SavingsAgreement';
import React from 'react';

export default function SavingsAgreementPage() {
  return <SavingsAgreement />;
}
